var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotfound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "animated",
    id: "freepik_stories-404-error",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes zoomIn{0%{opacity:0;transform:scale(.5)}to{opacity:1;transform:scale(1)}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes floating{0%,to{opacity:1;transform:translateY(0)}50%{transform:translateY(-10px)}}svg#freepik_stories-404-error:not(.animated) .animable{opacity:0}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-42",
    className: "animable",
    style: {
      transformOrigin: "250px 238.66px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.4 299.2c-13.68 13.39-16 34.11-13.1 52.26.08.41.72.3.72-.09 0-4.13-.13-8.22-.12-12.3.08-.19.14-.37.22-.55C90.69 335.92 94 333 96 329c2.29-4.5 3.19-9.56 4.93-14.26.17-.45-.31-.32-.63-.08-8.32 6.13-11 12.74-13.36 21.56a72.87 72.87 0 0 1 1.45-13.74c1.8-8.37 5.35-16.68 11.37-22.89a.25.25 0 0 0-.36-.39Z",
    style: {
      fill: "#a6a6a6",
      transformOrigin: "93.0821px 325.425px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    },
    id: "elrxm2h5m0vaa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 300.76c2.35.08 3.83 3.84 5.66 4.94a1.77 1.77 0 0 0 2.6-.41c1.82-2.54-.68-5.67-3-7.42 1.68.69 3.07 1.9 4.88 2.25a1.71 1.71 0 0 0 2.2-1.32c.79-3.46-3.54-5-6.52-5.07 1.44-1 5.58-3.73 3.38-5.07s-7.08 2.55-8.66 3.83c-2.33 1.89-5.1 4.71-5.21 7.66-.18 3.45 2.83 1.33 4.67.61Z",
    style: {
      fill: "#dbdbdb",
      transformOrigin: "105.878px 297.239px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: ".05555555555555555s",
      opacity: 0
    },
    id: "elcoohf2voooo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.29 301.34c3-1.37 8.79.6 9.28-.54 1-2.32-3.62-3.91-6.12-4.22 2.3-.62 6.7-1.61 6.57-3.82-.17-2.71-6.75-.38-10.09 2.17-4.19 3.22-4.17 6.33-3.47 6.95.95.85 3.33-.32 3.83-.54Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "104.066px 296.867px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: ".1111111111111111s",
      opacity: 0
    },
    id: "elxzkcel3hq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.24 297.87c14.18 12.86 17.27 33.48 15.07 51.73 0 .41-.7.33-.71-.06-.16-4.13-.19-8.23-.36-12.3l-.23-.55c-3.66-2.45-7.06-5.26-9.24-9.2-2.46-4.4-3.55-9.43-5.47-14.06-.18-.44.3-.33.62-.11 8.55 5.82 11.46 12.32 14.18 21.05a73.62 73.62 0 0 0-2-13.68c-2.12-8.3-6-16.46-12.24-22.44-.2-.25.14-.61.38-.38Z",
    style: {
      fill: "#a6a6a6",
      transformOrigin: "75.6061px 323.834px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: ".16666666666666666s",
      opacity: 0
    },
    id: "elh5ucvs2qsu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.73 299.53c-2.35.17-3.68 4-5.47 5.15a1.76 1.76 0 0 1-2.61-.31c-1.91-2.47.46-5.69 2.74-7.53-1.65.76-3 2-4.79 2.43a1.7 1.7 0 0 1-2.25-1.27c-.93-3.43 3.35-5.13 6.32-5.32-1.48-.94-5.72-3.51-3.57-4.93s7.17 2.28 8.8 3.5c2.4 1.8 5.28 4.51 5.49 7.46.27 3.48-2.82 1.47-4.66.82Z",
    style: {
      fill: "#dbdbdb",
      transformOrigin: "61.8135px 296.276px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: ".2222222222222222s",
      opacity: 0
    },
    id: "eln48v5ldwx0d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.43 300.08c-3.05-1.25-8.76.94-9.29-.18-1.08-2.28 3.47-4 6-4.45-2.32-.53-6.75-1.36-6.7-3.57.06-2.71 6.73-.64 10.16 1.79 4.31 3.06 4.4 6.16 3.73 6.81-.96.89-3.39-.19-3.9-.4Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "63.539px 295.713px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: ".2777777777777778s",
      opacity: 0
    },
    id: "ellbk30oj0s8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.74 331.84a139.59 139.59 0 0 0 4.41 20.34.51.51 0 0 0 1-.2c-.93-6.26-2.63-12.42-3.56-18.68a93.45 93.45 0 0 1-1.09-19.19c.59-10.56 3.46-21.8 10.35-30.06.16-.2-.17-.47-.32-.29-13.8 16.09-11.6 35.81-11.59 37.58-2-6.66-4-14.3-11.36-21.08-.32-.29-.57-.15-.51.35C71.38 313 74.81 319.41 82 326c.18 2 .43 3.92.74 5.84Z",
    style: {
      fill: "#a6a6a6",
      transformOrigin: "81.9769px 318.141px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: ".3333333333333333s",
      opacity: 0
    },
    id: "elzzvakghk9zd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 285.9c2.48-1.1 5.91 2.06 8.36 2.27a2 2 0 0 0 2.49-1.73c.61-3.55-3.55-5.54-6.87-6.17 2.09-.13 4.14.42 6.19-.13a2 2 0 0 0 1.62-2.48c-.91-4-6.19-3.4-9.31-2 1-1.77 3.91-6.68 1-7s-6.06 6.21-7.05 8.34c-1.47 3.13-2.93 7.46-1.55 10.57 1.52 3.71 3.57-.01 5.12-1.67Z",
    style: {
      fill: "#dbdbdb",
      transformOrigin: "97.0907px 278.905px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: ".38888888888888884s",
      opacity: 0
    },
    id: "eleconnwx89zf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.55 286.84c2.44-2.93 9.43-3.8 9.36-5.23-.13-2.9-5.72-2.23-8.46-1.29 2.06-1.8 6.13-5.05 4.88-7.28-1.54-2.72-7.2 3-9.37 7.34-2.73 5.45-1.14 8.66-.11 8.95 1.42.41 3.3-2 3.7-2.49Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "95.6774px 280.855px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: ".4444444444444444s",
      opacity: 0
    },
    id: "elvuchqsvibe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.66 335.56-6.08 46.5h37c-.76-4.12-7.65-46.55-7.65-46.55Z",
    style: {
      fill: "#dbdbdb",
      transformOrigin: "86.08px 358.785px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: ".5s",
      opacity: 0
    },
    id: "elx3h4i0w6eqj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "125.67px 100.855px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: ".8888888888888888s",
      opacity: 0
    },
    id: "elq0qtxpjvz0c",
    className: "animable",
    d: "M112.43 95.26h26.48v11.19h-26.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "110.89px 114.965px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: ".9444444444444444s",
      opacity: 0
    },
    id: "eluienpzzgh9r",
    className: "animable",
    d: "M97.65 109.37h26.48v11.19H97.65z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-42",
    className: "animable",
    style: {
      transformOrigin: "250px 382.02px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "250px 382.02px"
    },
    id: "elewebo9wc4w9",
    className: "animable",
    d: "m57.95 382.02 48.01-.24 48.01-.09 96.03-.17 96.02.17 48.02.09 48.01.24-48.01.25-48.02.08-96.02.17-96.03-.17-48.01-.09-48.01-.24z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--error-404--inject-42",
    className: "animable animator-active",
    style: {
      transformOrigin: "249.88px 273.705px",
      animation: "3.1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.4 239.88a9.17 9.17 0 0 0-.82-.83 10.7 10.7 0 0 0-.83-.82 10.7 10.7 0 0 0-.82-.83 9.17 9.17 0 0 0-.83-.82c-.26-.29-.54-.57-.82-.83a7.93 7.93 0 0 0-.82-.82 10.83 10.83 0 0 0-.83-.83 7.93 7.93 0 0 0-.82-.82 10.7 10.7 0 0 0-.83-.82 11.93 11.93 0 0 0-2.93-2.35v-82.64c0-.44-.21-.66-.21-1.1a2.35 2.35 0 0 0-.22-1.31c0-.22-.21-.66-.21-.88a10.41 10.41 0 0 0-.45-1.32 1.61 1.61 0 0 1-.43-.88 6.28 6.28 0 0 0-.88-1.09c-.23-.22-.44-.65-.66-.88l-.88-.88c0-.13-.17-.27-.36-.35l-.43-.44h-.05c0-.14-.16-.27-.35-.36l-.44-.43c0-.13-.17-.27-.36-.36l-.43-.43c0-.14-.17-.27-.36-.36l-.43-.44c0-.13-.17-.27-.36-.36l-.44-.43v-.05c0-.13-.17-.26-.36-.35l-.43-.44h-.05c0-.13-.16-.27-.35-.36l-.44-.43v-.05c0-.13-.17-.26-.36-.35l-.43-.44h-.05c0-.14-.16-.27-.35-.36l-.44-.43c0-.13-.17-.27-.36-.35l-.48-.48c0-.22-.43-.44-.66-.44a.21.21 0 0 0-.21-.22c-.44-.21-.67-.44-1.1-.66a13.54 13.54 0 0 1-1.09-.88c-.22 0-.66-.21-.88-.21-.44-.22-1.1-.22-1.32-.45a2.1 2.1 0 0 1-1.1-.21h-3.72a1.37 1.37 0 0 1-.88.21c-.66.23-1.09.23-1.32.45-.43 0-.65.21-.88.66a2.38 2.38 0 0 0-1.31.43c-.21.22-.66.45-.88.66a2.25 2.25 0 0 1-1.09.66 3 3 0 0 1-.66.88c-.22.22-.22.43-.43.43L52 233a11.71 11.71 0 0 0 1.09 16.13 7.4 7.4 0 0 0 .84.84 6.51 6.51 0 0 0 .83.83 7.4 7.4 0 0 0 .84.84 7.31 7.31 0 0 0 .83.84 7.31 7.31 0 0 0 .84.83 7.31 7.31 0 0 0 .83.84 7.31 7.31 0 0 0 .84.83 7.31 7.31 0 0 0 .83.84 7.31 7.31 0 0 0 .84.83 11.38 11.38 0 0 0 1.72 1.59 10.75 10.75 0 0 0 7.45 2.63h60.72v8.31a12 12 0 0 0 3.92 9c.26.28.53.55.8.8a10.32 10.32 0 0 0 .81.81c.26.28.53.55.81.8a10.32 10.32 0 0 0 .81.81q.39.42.81.81a8.85 8.85 0 0 0 .81.81c.25.28.52.55.8.81a10.32 10.32 0 0 0 .81.81c.25.27.52.54.8.8a12.11 12.11 0 0 0 21-8.19v-16.42h2.2a12.07 12.07 0 0 0 12.27-12.06 12 12 0 0 0-3.75-8.89Zm-42.92-47v35.44h-28.56Z",
    style: {
      fill: "#1952a9",
      transformOrigin: "113.22px 208.668px",
      animation: "3.1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    },
    id: "elggcheilvvkj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.06 240.41a12.07 12.07 0 0 1-12.28 12.06h-2.19v16.67a12.06 12.06 0 0 1-24.12 0v-16.67H61.4a10.71 10.71 0 0 1-7.4-2.63A11.73 11.73 0 0 1 52 233l81.1-100.91c.22 0 .22-.21.44-.43a3 3 0 0 0 .66-.88 2.35 2.35 0 0 0 1.1-.66c.21-.22.65-.44.87-.66a2.36 2.36 0 0 1 1.32-.44c.22-.43.44-.65.88-.65.21-.22.65-.22 1.31-.44a1.32 1.32 0 0 0 .88-.22h3.73a1.93 1.93 0 0 0 1.09.22c.22.22.88.22 1.32.44.22 0 .66.22.88.22.43.43.87.65 1.09.87.44.22.66.44 1.1.66a.22.22 0 0 1 .22.22c.22 0 .66.22.66.44l.87.88c.22.22.44.65.66.87a6 6 0 0 1 .88 1.1 1.67 1.67 0 0 0 .44.88 8 8 0 0 1 .43 1.31c0 .22.22.66.22.88a2.38 2.38 0 0 1 .22 1.32c0 .43.22.65.22 1.09v89.24h2.19a12.22 12.22 0 0 1 12.28 12.06Zm-38.59-66.22-43.63 54.16h43.63Z",
    style: {
      fill: "#1952a9",
      transformOrigin: "109.189px 204.455px",
      animation: "3.1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: ".20666666666666667s",
      opacity: 0
    },
    id: "elt6t4xm6lro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.33 160.4a62.28 62.28 0 0 0-8.58-10.4 4.4 4.4 0 0 0-.38-.37l-.11-.11c-.1-.11-.2-.22-.31-.32-.28-.3-.58-.58-.87-.87l-.08-.07-.3-.3a1.14 1.14 0 0 0-.11-.11c-.1-.11-.2-.22-.31-.32-.28-.3-.58-.58-.87-.87l-.08-.07-.3-.3-.11-.11c-.1-.11-.2-.22-.31-.32-.28-.3-.58-.58-.87-.87l-.08-.07-.3-.3s-.07-.08-.11-.11a3.22 3.22 0 0 0-.32-.32c-.27-.31-.57-.58-.86-.87l-.08-.07a2.83 2.83 0 0 0-.3-.3s-.07-.08-.11-.11c-8.81-9.08-20.29-15.09-33.17-15.09-17.33 0-31.57 10.31-40.79 24.33-9.65 14-14.68 32.25-14.9 52.41.22 20 5.25 38.37 14.9 52.41a65.26 65.26 0 0 0 8.49 10.29l.44.43v.05l.78.78c.13.15.27.28.4.41l.44.43.05.05.78.78.4.42.44.42a.12.12 0 0 1 .05.05l.78.78.4.42.44.42a.1.1 0 0 1 .05.06l.78.78.41.41.43.42.06.06.78.78c8.66 8.65 19.84 14.46 32.69 14.46 16.88 0 31.35-10.53 40.57-24.35 9.42-14 14.69-32.45 14.69-52.4.03-20.21-5.22-38.41-14.64-52.45Zm-28.53 82.87c-6.36 9.42-13.6 13.59-20.39 13.59a20.15 20.15 0 0 1-11.57-4c-.31-.4-.61-.82-.91-1.26-6.14-9.21-10.53-23.24-10.53-38.81 0-15.79 4.39-29.6 10.53-39 6.59-9.21 14-13.59 20.83-13.38a18.35 18.35 0 0 1 11 3.6c.35.47.69.93 1 1.42 6.14 9.43 10.52 23.24 10.52 39 .04 15.57-4.34 29.62-10.48 38.84Z",
    style: {
      fill: "#1952a9",
      transformOrigin: "252.345px 208.675px",
      animation: "3.1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: ".31s",
      opacity: 0
    },
    id: "el13xmy3xknpx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.71 204.45c.22-20.17 5.27-38.37 14.91-52.4 9.21-14 23.46-24.34 40.79-24.34 16.88 0 31.35 10.31 40.56 24.34 9.43 14 14.69 32.23 14.69 52.4 0 20-5.26 38.38-14.69 52.41-9.21 13.81-23.68 24.34-40.56 24.34-17.33 0-31.58-10.53-40.79-24.34-9.62-14.03-14.69-32.45-14.91-52.41Zm86.61 0c0-15.78-4.38-29.6-10.52-39-6.36-9.21-13.59-13.59-20.39-13.37-6.8-.22-14.26 4.16-20.83 13.37-6.14 9.43-10.53 23.25-10.53 39 0 15.57 4.39 29.61 10.53 38.81 6.57 9.43 14 13.6 20.83 13.6s14-4.17 20.39-13.6c6.14-9.2 10.52-23.26 10.52-38.81Z",
    style: {
      fill: "#1952a9",
      transformOrigin: "248.185px 204.455px",
      animation: "3.1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: ".5166666666666666s",
      opacity: 0
    },
    id: "elr9p8fcgbjdi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.71 239.88c-.26-.29-.54-.57-.82-.83-.27-.29-.55-.56-.83-.82-.27-.29-.54-.57-.82-.83-.27-.29-.55-.57-.83-.82-.27-.29-.54-.57-.82-.83-.27-.29-.55-.57-.83-.82-.27-.29-.55-.57-.82-.83a10.57 10.57 0 0 0-.82-.82c-.27-.29-.55-.56-.83-.82a11.75 11.75 0 0 0-2.94-2.35v-82.64c0-.44-.21-.66-.21-1.1a2.35 2.35 0 0 0-.22-1.31c0-.22-.21-.66-.21-.88a10.41 10.41 0 0 0-.45-1.32 1.69 1.69 0 0 1-.43-.88 5.83 5.83 0 0 0-.88-1.09c-.23-.22-.44-.65-.66-.88l-.88-.88c0-.13-.17-.27-.36-.35l-.43-.44h-.05c0-.14-.16-.27-.35-.36l-.44-.43c0-.13-.17-.27-.36-.36l-.43-.43c0-.14-.17-.27-.36-.36l-.43-.44c0-.13-.17-.27-.36-.36l-.44-.43v-.05c0-.13-.17-.26-.36-.35l-.43-.44h-.05c0-.13-.16-.27-.35-.36l-.44-.43v-.05c0-.13-.17-.26-.36-.35l-.43-.44h-.05c0-.14-.16-.27-.35-.36l-.44-.43c0-.13-.17-.27-.36-.35l-.48-.48c0-.22-.43-.44-.66-.44a.22.22 0 0 0-.22-.22c-.43-.21-.66-.44-1.09-.66a13.54 13.54 0 0 1-1.09-.88c-.22 0-.66-.21-.88-.21-.44-.22-1.09-.22-1.32-.45a2.08 2.08 0 0 1-1.1-.21h-3.72a1.37 1.37 0 0 1-.88.21c-.66.23-1.09.23-1.32.45-.43 0-.65.21-.88.66a2.4 2.4 0 0 0-1.31.43c-.21.22-.66.45-.87.66a2.35 2.35 0 0 1-1.1.66 3.18 3.18 0 0 1-.66.88c-.22.22-.22.43-.43.43L325.28 233a11.71 11.71 0 0 0 1.09 16.13 7.4 7.4 0 0 0 .84.84 6.51 6.51 0 0 0 .83.83 7.4 7.4 0 0 0 .84.84 295.81 295.81 0 0 1 2.5 2.51 98.61 98.61 0 0 1 1.67 1.67 7.31 7.31 0 0 0 .84.83 11.38 11.38 0 0 0 1.72 1.59 10.75 10.75 0 0 0 7.45 2.63h60.72v8.31a12 12 0 0 0 3.92 9c.26.29.54.56.81.81.25.28.52.54.8.8a10.42 10.42 0 0 0 .82.81c.26.28.52.54.8.8.26.29.54.56.82.82.26.28.52.55.8.8.26.29.54.56.82.82.26.28.52.55.8.8a10.45 10.45 0 0 0 .81.82 12.11 12.11 0 0 0 21-8.2v-16.43h2.2a12.08 12.08 0 0 0 12.29-12.06 12 12 0 0 0-3.76-8.89Zm-42.93-47v35.44h-28.56Z",
    style: {
      fill: "#1952a9",
      transformOrigin: "386.52px 208.678px",
      animation: "3.1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: ".62s",
      opacity: 0
    },
    id: "eltughy4qdtci",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.36 240.41a12.07 12.07 0 0 1-12.28 12.06h-2.19v16.67a12.06 12.06 0 0 1-24.12 0v-16.67H334.7a10.71 10.71 0 0 1-7.45-2.63 11.73 11.73 0 0 1-2-16.88l81.15-100.87c.22 0 .22-.21.44-.43a3 3 0 0 0 .66-.88 2.35 2.35 0 0 0 1.1-.66c.22-.22.66-.44.88-.66a2.3 2.3 0 0 1 1.31-.44c.22-.43.44-.65.87-.65.22-.22.66-.22 1.32-.44a1.32 1.32 0 0 0 .88-.22h3.73a1.93 1.93 0 0 0 1.09.22c.22.22.88.22 1.32.44.22 0 .66.22.88.22.44.43.87.65 1.09.87.44.22.66.44 1.1.66a.22.22 0 0 1 .22.22c.22 0 .65.22.65.44l.88.88c.22.22.44.65.66.87a6 6 0 0 1 .88 1.1 1.67 1.67 0 0 0 .44.88 9 9 0 0 1 .44 1.31c0 .22.21.66.21.88a2.38 2.38 0 0 1 .22 1.32c0 .43.22.65.22 1.09v89.24h2.19a12.22 12.22 0 0 1 12.28 12.06Zm-38.59-66.22-43.63 54.16h43.63Z",
    style: {
      fill: "#1952a9",
      transformOrigin: "382.454px 204.455px",
      animation: "3.1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: ".8266666666666667s",
      opacity: 0
    },
    id: "elrcbukkrlkg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.49 103.68H165V108a1.11 1.11 0 0 1-2.22 0V96.22a1.1 1.1 0 0 1 1.1-1.1h3.58a4.28 4.28 0 1 1 0 8.56Zm-2.49-2.22h2.46a2.06 2.06 0 1 0 0-4.12H165Z",
    style: {
      fill: "#263238",
      transformOrigin: "167.263px 102.115px",
      animation: "3.1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: ".9299999999999999s",
      opacity: 0
    },
    id: "elbuf9rkuoic",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.21 105.83h-4.86l-1 2.6a1.12 1.12 0 0 1-1 .7 1.16 1.16 0 0 1-.38-.06 1.13 1.13 0 0 1-.66-1.44l4.42-11.79a1.12 1.12 0 0 1 1.06-.7 1.1 1.1 0 0 1 1.06.7l4.42 11.79a1.13 1.13 0 0 1-.66 1.44 1.12 1.12 0 0 1-1.4-.64Zm-.82-2.2-1.62-4.31-1.62 4.31Z",
    style: {
      fill: "#263238",
      transformOrigin: "177.79px 102.135px",
      animation: "3.1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "1.0333333333333332s",
      opacity: 0
    },
    id: "el57hp79tmfum",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.73 101.94a7.29 7.29 0 0 1 7.38-7.22 7.39 7.39 0 0 1 4.56 1.56 1.15 1.15 0 0 1 .22 1.62 1.16 1.16 0 0 1-1.62.18 5.2 5.2 0 0 0-3.16-1.08 5 5 0 0 0-3.6 1.46 4.75 4.75 0 0 0 0 6.93 5 5 0 0 0 3.6 1.46 5.52 5.52 0 0 0 2.74-.76v-2.75H192a1.15 1.15 0 0 1-1.14-1.14 1.12 1.12 0 0 1 1.14-1.12h4a1.13 1.13 0 0 1 1.16 1.12v4.43a1.72 1.72 0 0 1-.06.34s0 .06 0 .1a1 1 0 0 1-.38.48 7.38 7.38 0 0 1-4.54 1.56 7.27 7.27 0 0 1-7.45-7.17Z",
    style: {
      fill: "#263238",
      transformOrigin: "190.945px 101.916px",
      animation: "3.1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "1.1366666666666667s",
      opacity: 0
    },
    id: "el4frmmflc026",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.63 108V96.22a1.08 1.08 0 0 1 1.1-1.1h6.54a1.11 1.11 0 0 1 1.1 1.1 1.13 1.13 0 0 1-1.1 1.12h-5.42V101h4.66a1.11 1.11 0 0 1 0 2.22h-4.66v3.69h5.42a1.11 1.11 0 0 1 0 2.22h-6.48a1.1 1.1 0 0 1-1.16-1.13Z",
    style: {
      fill: "#263238",
      transformOrigin: "206.005px 102.126px",
      animation: "3.1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "1.24s",
      opacity: 0
    },
    id: "el1hbp6mppo5s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.69 108a1.09 1.09 0 1 1-2.18 0V96.38a1.08 1.08 0 0 1 .44-.92 1.1 1.1 0 0 1 1.52.24l6.46 9v-8.3a1.09 1.09 0 0 1 1.07-1.08 1.11 1.11 0 0 1 1.1 1.08V108a1.11 1.11 0 0 1-1.1 1.1 1.08 1.08 0 0 1-.82-.4.53.53 0 0 1-.1-.12l-6.4-8.89Z",
    style: {
      fill: "#263238",
      transformOrigin: "224.804px 102.178px",
      animation: "3.1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "1.3433333333333333s",
      opacity: 0
    },
    id: "elwvvhatejcws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 96.86a7.36 7.36 0 0 1 0 10.14 6.55 6.55 0 0 1-4.78 2.14 6.75 6.75 0 0 1-4.9-2.14 7.47 7.47 0 0 1 0-10.13 6.67 6.67 0 0 1 4.9-2.14 6.48 6.48 0 0 1 4.78 2.13Zm-.26 5.06a5.18 5.18 0 0 0-1.36-3.5 4.32 4.32 0 0 0-6.4 0 5.09 5.09 0 0 0-1.36 3.5 5 5 0 0 0 1.36 3.49 4.28 4.28 0 0 0 6.4 0 5.12 5.12 0 0 0 1.31-3.49Z",
    style: {
      fill: "#263238",
      transformOrigin: "240.183px 101.935px",
      animation: "3.1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "1.4466666666666668s",
      opacity: 0
    },
    id: "elmrrfbkdkv7m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.37 97.34h-3.18V108a1.08 1.08 0 0 1-1.1 1.1A1.1 1.1 0 0 1 253 108V97.34h-3.16a1.11 1.11 0 0 1-1.1-1.12 1.08 1.08 0 0 1 1.1-1.1h8.54a1.1 1.1 0 0 1 1.1 1.1 1.13 1.13 0 0 1-1.11 1.12Z",
    style: {
      fill: "#263238",
      transformOrigin: "254.11px 102.11px",
      animation: "3.1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "1.55s",
      opacity: 0
    },
    id: "eljye691c11r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.77 108V96.22a1.1 1.1 0 0 1 1.1-1.1h6.54a1.11 1.11 0 0 1 0 2.22H271V101h4.66a1.11 1.11 0 0 1 0 2.22H271V108a1.11 1.11 0 0 1-1.12 1.1 1.1 1.1 0 0 1-1.11-1.1Z",
    style: {
      fill: "#263238",
      transformOrigin: "273.145px 102.11px",
      animation: "3.1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "1.6533333333333333s",
      opacity: 0
    },
    id: "eluyui35anz6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.51 96.86a7.36 7.36 0 0 1 0 10.13 6.55 6.55 0 0 1-4.78 2.14 6.75 6.75 0 0 1-4.9-2.14 7.47 7.47 0 0 1 0-10.13 6.67 6.67 0 0 1 4.9-2.14 6.48 6.48 0 0 1 4.78 2.14Zm-.26 5.06a5.18 5.18 0 0 0-1.36-3.5 4.32 4.32 0 0 0-6.4 0 5.09 5.09 0 0 0-1.36 3.5 5 5 0 0 0 1.36 3.49 4.28 4.28 0 0 0 6.4 0 5.12 5.12 0 0 0 1.36-3.49Z",
    style: {
      fill: "#263238",
      transformOrigin: "286.69px 101.925px",
      animation: "3.1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "1.7566666666666666s",
      opacity: 0
    },
    id: "elc3m825269",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.37 109.13a5.77 5.77 0 0 1-5.78-5.79v-7.12a1.08 1.08 0 0 1 1.1-1.1 1.11 1.11 0 0 1 1.12 1.1v7.12a3.56 3.56 0 1 0 7.12 0v-7.12a1.1 1.1 0 0 1 1.12-1.1 1.08 1.08 0 0 1 1.1 1.1v7.12a5.78 5.78 0 0 1-5.78 5.79Z",
    style: {
      fill: "#263238",
      transformOrigin: "302.37px 102.125px",
      animation: "3.1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "1.8599999999999999s",
      opacity: 0
    },
    id: "elesef02y1mjl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.75 108a1.09 1.09 0 1 1-2.18 0V96.38a1.08 1.08 0 0 1 .44-.92 1.1 1.1 0 0 1 1.52.24l6.46 9v-8.3a1.09 1.09 0 0 1 1.08-1.08 1.11 1.11 0 0 1 1.1 1.08V108a1.11 1.11 0 0 1-1.1 1.1 1.08 1.08 0 0 1-.82-.4.53.53 0 0 1-.1-.12l-6.4-8.89Z",
    style: {
      fill: "#263238",
      transformOrigin: "317.869px 102.178px",
      animation: "3.1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "1.9633333333333334s",
      opacity: 0
    },
    id: "elq3f4vs2fgg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327 108V96.22a1.08 1.08 0 0 1 1.1-1.1h2.36a7 7 0 0 1 0 14h-2.36A1.1 1.1 0 0 1 327 108Zm2.22-1.12h1.24a4.79 4.79 0 0 0 0-9.57h-1.24Z",
    style: {
      fill: "#263238",
      transformOrigin: "332.23px 102.12px",
      animation: "3.1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "2.0666666666666664s",
      opacity: 0
    },
    id: "elhtrp88r3hzw",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-42",
    className: "animable",
    style: {
      transformOrigin: "314.823px 279.383px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.27 252.75a1 1 0 0 0 .65 1.09c1.05.16 2.33.33 3.75.53 4.23-9.18 8.55-16.41 7.33-13.55a51.85 51.85 0 0 0-3.63 14.06c1.65.22 5.5.69 7.42.92 4.42-16.38 9.29-28.42 8.72-24.64-2.32 15.25-1.91 20.23-1.38 25.56 17.93 2.18 41.48 4.76 58.55 6.23 2.79-9 5.4-18.84 5.64-18.12 1.87 5.35 1.83 12.91 1.36 18.71 5.44.43 9.8.66 12.47.66 0 0 2-7.62 2.36-10.14a56.27 56.27 0 0 0-.18-19.46c-1.23-6.56-3.85-12.46-6.3-18.49a.81.81 0 0 0-.03-.11 56 56 0 0 1-3.48-12.29.25.25 0 0 1 0-.1 55.34 55.34 0 0 1-.59-9.29c.22-11.38-4.88-21.61-14.57-25.31-16.55-16.91-39.28-9.15-45.7 5.15-2.51 6.41-5 14.78-7.17 21.23a.07.07 0 0 1 0 .07 65.64 65.64 0 0 1-2.91 7.42c-5.95 11.52-17.41 17.46-22.31 49.87Z",
    style: {
      fill: "#263238",
      transformOrigin: "332.264px 211.8px"
    },
    id: "ely3jbyzmnzj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.35 172.37c6.21 4.11 9.75 9.72 10 18.06.16 4.86 0 9.59 1.37 14.26 1.37 4.82 3.85 8.88 6.42 12.93 4.07 6.44 6.75 12.76 6.74 20.92s-1.24 18-4.53 25.49c0 .05-.08 0-.06 0 2.8-7.65 3.82-18.43 3.25-26.69-.63-9.08-4.87-15.06-9.13-22.23a38.45 38.45 0 0 1-5.51-18.82c-.12-4.12.32-8.37-.88-12.33-1.42-4.72-4.82-7.91-8.22-10.76-.45-.41.08-1.14.55-.83Z",
    style: {
      fill: "#263238",
      transformOrigin: "374.255px 218.174px"
    },
    id: "elzow3xryvytc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.36 214.81c5.18-6.09 10.47-11.22 13.89-19 3.11-7.09 5.2-14.66 8.35-21.73 0-.12.21-.06.16.07-5 12.6-6.92 25.54-15.66 35.81-4.76 5.58-9.47 10.73-12.89 17.58a67.83 67.83 0 0 0-6.46 23c0 .28-.37.24-.37 0a55.61 55.61 0 0 1 12.98-35.73Z",
    style: {
      fill: "#263238",
      transformOrigin: "295.074px 212.375px"
    },
    id: "elpy6d97sh4vq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 370s48.27 13 56.25 11.6 34.92-37.66 40.9-50.81 15.91-78.57 14-85.77-11.9-7.3-20.33 11.26-28.36 59.36-31.91 62.72-62.8 47.52-58.91 51Z",
    style: {
      fill: "#dd6a57",
      transformOrigin: "295.603px 311.113px"
    },
    id: "elc4li02a3hml",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.06 377.3c-7.4-3.87-16.41-13.26-22.55-14.24a7.13 7.13 0 0 0-7.67 3.66s-2.82-6.27-8.54-6.24c-2.93 0-5.49 4.72-5.49 4.72s-2.49-4.93-7.56-4.59c-4.05.27-6 4.95-6 4.95s-4.58-3.62-8.62-2c-8.18 3.23-9.54 38 3.06 43.88 5.87 2.74 5.74-5.77 5.74-5.77s3.14 12.2 10.3 12.66 6.33-10.58 6.33-10.58 3.15 11.79 10.62 11.52c7.78-.27 5.06-11.18 5.06-11.18s4.94 7.94 10.61 6.42c9.37-2.5-.7-21.32 1.42-28.89h11.77Z",
    style: {
      fill: "#dd6a57",
      transformOrigin: "255.707px 387.877px"
    },
    id: "elm36gmkc9oy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.38 369.9c7.33 3.06 15.69-8.51 23.23-5.82 9.78 3.49.74 15.56-14.08 17.52h-11.77Z",
    style: {
      fill: "#dd6a57",
      transformOrigin: "293.724px 372.635px"
    },
    id: "elre74ymf1tnn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.82 366.25a.09.09 0 0 0-.18 0c-3.23 11.33-3.32 24.77.73 35.91.13.36.79.31.72-.12-1.98-12.32-2.76-23.38-1.27-35.79Z",
    style: {
      fill: "#263238",
      transformOrigin: "233.182px 384.28px"
    },
    id: "elugdhb2dt54",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.74 365c0-.14-.21-.17-.25 0-3.27 11.7-3 26.83 3.23 39.13.21.42.83.58.62.08-3.49-8.48-5-28.02-3.6-39.21Z",
    style: {
      fill: "#263238",
      transformOrigin: "248.401px 384.702px"
    },
    id: "elojh0c67haxh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.46 404.82c-5.47-12-6.54-24.57-5.78-37.63 0-.17-.23-.17-.28 0-2.11 6.29-1.72 14.66-.87 21.15A34.7 34.7 0 0 0 267 405c.18.21.58.08.46-.18Z",
    style: {
      fill: "#263238",
      transformOrigin: "263.665px 386.084px"
    },
    id: "elc0lzdxfmag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.19 363.16c-4.8-1.6-9.73 2.24-13.77 4.39a24 24 0 0 1-4.07 1.93c-3.2 1-5.57.36-7-.53-2.24-1.43-9.23-8.41-14.28-6.09a10.76 10.76 0 0 0-4.32 3.67c-1.54-2.8-3.51-5.85-6.92-6.41a5.4 5.4 0 0 0-4.28 1.11 8.78 8.78 0 0 0-1.68 1.71 7.93 7.93 0 0 0-1.16 1.91.64.64 0 0 1 0-.07l-.11-.21-.21-.43a4.49 4.49 0 0 0-1.19-1.49 1 1 0 0 0-.73-.3.08.08 0 0 0 0 .16 1.16 1.16 0 0 1 .54.53c.16.24.31.49.48.72s.33.47.5.7l.25.37.11.19a1.29 1.29 0 0 0 .16.17.15.15 0 0 0 .24 0 10 10 0 0 0 1.39-1.52 12 12 0 0 1 1.67-1.6 5.19 5.19 0 0 1 4.11-1c3.06.6 5 3.32 6.63 5.75h.05c-.05.08.06.15.12.09 1.68-1.47 3.28-3.12 5.6-3.46 2.5-.37 4.87.83 6.94 2.09a32 32 0 0 1 3 2c.85.66 1.66 1.4 2.57 2 3.89 2.45 8.15.55 9.21.1a53.35 53.35 0 0 0 6.07-3.22 17.12 17.12 0 0 1 6.5-2.63 6.39 6.39 0 0 1 5.78 2.16c.73.94 1.66 2.7-.25 6.71 0 0 0 .08.06.05 1-1.04 4.18-7.48-2.01-9.55Z",
    style: {
      fill: "#263238",
      transformOrigin: "277.149px 366.38px"
    },
    id: "elzhi9koz89np",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.36 305.78-45.55-7.28s21.76-43.09 34.83-55.59c12.9-12.34 19.18.3 17.28 19.36-2.1 21.13-6.56 43.51-6.56 43.51Z",
    style: {
      fill: "#37474f",
      transformOrigin: "328.032px 271.895px"
    },
    id: "elrkr20nxc4nj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.88 297.3c-1.28-.3-2.59-.49-3.87-.78s-2.51-.47-3.77-.66c-2.57-.4-5.15-.76-7.72-1.11-5.08-.7-10.16-1.47-15.26-2-2.9-.32-5.78-.76-8.69-1-.09 0-.1.14 0 .16 5.05 1.18 10.19 2 15.31 2.89s10.16 1.61 15.26 2.16c1.43.16 2.87.34 4.3.41s2.95.21 4.42.23a.12.12 0 0 0 .02-.3Z",
    style: {
      fill: "#263238",
      transformOrigin: "326.26px 294.675px"
    },
    id: "elg1g04i6pwt4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322 382h120.63S392.49 257.56 367 239.38c-7.65-5.46-19.84-6.07-28.06 4.89-6.74 9-25.45 44.75-26.3 57.61s9.24 25.57 9.24 25.57Z",
    style: {
      fill: "#455a64",
      transformOrigin: "377.61px 308.78px"
    },
    id: "elh6qhdsbwsso",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.94 297.68c.31-.08.61-.12.91-.18a1.81 1.81 0 0 1 2.21 1.76 1.4 1.4 0 0 0 .64 1.22 1.76 1.76 0 0 0 .75.26 9.15 9.15 0 0 1 .91.18c-.3.08-.6.12-.91.18a1.78 1.78 0 0 1-1-.09 1.86 1.86 0 0 1-1.13-1.73 1.43 1.43 0 0 0-.69-1.19 1.94 1.94 0 0 0-.77-.23c-.31-.06-.61-.1-.92-.18Z",
    style: {
      fill: "#fff",
      transformOrigin: "364.65px 299.295px"
    },
    id: "elkun5cwj3kwb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.8 297.68c.3-.08.6-.12.9-.18a1.81 1.81 0 0 1 2.21 1.76 1.41 1.41 0 0 0 .65 1.22 1.67 1.67 0 0 0 .75.26c.3.06.6.09.9.18-.3.08-.6.12-.9.18a1.81 1.81 0 0 1-1-.09 1.89 1.89 0 0 1-1.13-1.73 1.43 1.43 0 0 0-.69-1.19 1.89 1.89 0 0 0-.77-.23c-.32-.06-.62-.1-.92-.18Z",
    style: {
      fill: "#fff",
      transformOrigin: "318.505px 299.294px"
    },
    id: "el27ei8pm5h86",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.7 357.62c.3-.08.61-.12.91-.18a1.82 1.82 0 0 1 2.2 1.77 1.44 1.44 0 0 0 .65 1.22 1.75 1.75 0 0 0 .75.25c.3.06.61.1.91.18-.3.09-.61.13-.91.19a1.79 1.79 0 0 1-1-.1 1.88 1.88 0 0 1-1.14-1.73 1.37 1.37 0 0 0-.69-1.18 1.7 1.7 0 0 0-.76-.23c-.31-.06-.62-.1-.92-.19Z",
    style: {
      fill: "#fff",
      transformOrigin: "381.41px 359.24px"
    },
    id: "eldletdsh1t7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.56 300.92c.3-.09.61-.12.91-.18a1.8 1.8 0 0 1 2.2 1.76 1.43 1.43 0 0 0 .65 1.22 1.59 1.59 0 0 0 .75.25c.3.07.61.1.91.19-.3.08-.61.12-.91.18a1.77 1.77 0 0 1-1-.09 1.88 1.88 0 0 1-1.14-1.73 1.39 1.39 0 0 0-.69-1.19 1.84 1.84 0 0 0-.76-.23c-.31-.1-.62-.1-.92-.18Z",
    style: {
      fill: "#fff",
      transformOrigin: "402.27px 302.535px"
    },
    id: "eldd9lbgmy8ak",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.23 270.43c.31-.08.61-.12.91-.18a1.78 1.78 0 0 1 1 .07 1.83 1.83 0 0 1 1.19 1.7 1.46 1.46 0 0 0 .65 1.22 1.9 1.9 0 0 0 .75.25c.31.06.61.1.91.18-.3.09-.6.12-.91.19a1.88 1.88 0 0 1-1-.1 1.86 1.86 0 0 1-1.13-1.76 1.4 1.4 0 0 0-.69-1.18 1.79 1.79 0 0 0-.77-.24c-.3-.03-.6-.06-.91-.15Z",
    style: {
      fill: "#fff",
      transformOrigin: "348.935px 272.048px"
    },
    id: "el9jy79b7x22s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.06 269.74c.3-.08.6-.12.91-.18a1.83 1.83 0 0 1 1 .07 1.86 1.86 0 0 1 1.2 1.7 1.42 1.42 0 0 0 .65 1.22 1.71 1.71 0 0 0 .75.25c.3.06.6.1.91.18-.31.09-.61.13-.91.19a1.78 1.78 0 0 1-1-.1 1.88 1.88 0 0 1-1.14-1.73 1.39 1.39 0 0 0-.69-1.18 1.7 1.7 0 0 0-.76-.23 9.18 9.18 0 0 1-.92-.19Z",
    style: {
      fill: "#fff",
      transformOrigin: "381.77px 271.361px"
    },
    id: "elkz4caecvvyg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.81 238.23c.3-.08.61-.12.91-.18a1.8 1.8 0 0 1 2.2 1.76 1.41 1.41 0 0 0 .65 1.22 1.71 1.71 0 0 0 .75.26c.3.06.61.09.91.18-.3.08-.61.12-.91.18a1.77 1.77 0 0 1-1-.09 1.88 1.88 0 0 1-1.14-1.73 1.39 1.39 0 0 0-.69-1.19 1.84 1.84 0 0 0-.76-.23c-.31-.06-.62-.1-.92-.18Z",
    style: {
      fill: "#fff",
      transformOrigin: "360.52px 239.845px"
    },
    id: "elqt6h41r1pqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.18 322.76c.3-.08.6-.12.9-.18a1.77 1.77 0 0 1 1 .07 1.83 1.83 0 0 1 1.2 1.69 1.41 1.41 0 0 0 .65 1.22 1.67 1.67 0 0 0 .75.26c.3.06.6.1.9.18-.3.09-.6.12-.9.18a1.81 1.81 0 0 1-1-.09 1.89 1.89 0 0 1-1.13-1.73 1.43 1.43 0 0 0-.69-1.19 1.94 1.94 0 0 0-.77-.23c-.31-.06-.61-.09-.91-.18Z",
    style: {
      fill: "#fff",
      transformOrigin: "340.88px 324.376px"
    },
    id: "elh5um6yg00p7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374 377.69c.3-.09.61-.13.91-.19a1.82 1.82 0 0 1 2.2 1.77 1.44 1.44 0 0 0 .65 1.22 1.63 1.63 0 0 0 .75.25c.3.06.61.1.91.18-.3.09-.61.13-.91.19a1.79 1.79 0 0 1-1-.1 1.87 1.87 0 0 1-1.14-1.73 1.37 1.37 0 0 0-.69-1.18 1.7 1.7 0 0 0-.76-.23c-.34-.06-.65-.1-.92-.18Z",
    style: {
      fill: "#fff",
      transformOrigin: "376.71px 379.3px"
    },
    id: "elmpl5yyhstif",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.35 348.17c.3-.08.6-.12.9-.18a1.86 1.86 0 0 1 1 .07 1.84 1.84 0 0 1 1.2 1.7 1.42 1.42 0 0 0 .65 1.22 1.66 1.66 0 0 0 .75.25c.3.06.6.1.91.18-.31.09-.61.12-.91.19a1.91 1.91 0 0 1-1-.1 1.89 1.89 0 0 1-1.13-1.73 1.42 1.42 0 0 0-.69-1.18 1.59 1.59 0 0 0-.77-.23c-.26-.07-.61-.1-.91-.19Z",
    style: {
      fill: "#fff",
      transformOrigin: "359.055px 349.789px"
    },
    id: "el0fuw5dhx25wf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.74 353.54c.31-.09.61-.13.91-.19a1.82 1.82 0 0 1 2.2 1.77 1.44 1.44 0 0 0 .65 1.22 1.63 1.63 0 0 0 .75.25c.31.06.61.1.91.18a9.18 9.18 0 0 1-.91.19 1.79 1.79 0 0 1-1-.1 1.87 1.87 0 0 1-1.14-1.73 1.38 1.38 0 0 0-.68-1.18 1.79 1.79 0 0 0-.77-.23c-.31-.06-.61-.1-.92-.18Z",
    style: {
      fill: "#fff",
      transformOrigin: "326.45px 355.15px"
    },
    id: "elu499dp7qkzo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.36 323.48c.3-.08.6-.12.9-.18a1.83 1.83 0 0 1 2.21 1.77 1.42 1.42 0 0 0 .65 1.22 1.66 1.66 0 0 0 .75.25c.3.06.6.1.9.18-.3.09-.6.12-.9.19a1.82 1.82 0 0 1-1-.1 1.89 1.89 0 0 1-1.13-1.73 1.42 1.42 0 0 0-.69-1.18 1.66 1.66 0 0 0-.77-.23c-.28-.07-.62-.1-.92-.19Z",
    style: {
      fill: "#fff",
      transformOrigin: "374.065px 325.1px"
    },
    id: "elzhkmp3gdqzm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.05 363.89c.3-.08.61-.12.91-.18a1.78 1.78 0 0 1 1 .07 1.83 1.83 0 0 1 1.19 1.7 1.46 1.46 0 0 0 .65 1.22 1.9 1.9 0 0 0 .75.25c.31.06.61.1.91.18-.3.09-.6.12-.91.19a1.82 1.82 0 0 1-2.15-1.83 1.37 1.37 0 0 0-.69-1.18 1.7 1.7 0 0 0-.76-.24c-.29-.07-.6-.07-.9-.18Z",
    style: {
      fill: "#fff",
      transformOrigin: "415.755px 365.51px"
    },
    id: "eltmkv1l00w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.5 339.22c.3-.08.61-.12.91-.18a1.82 1.82 0 0 1 2.2 1.77 1.42 1.42 0 0 0 .65 1.22 1.59 1.59 0 0 0 .75.25c.3.06.61.1.91.18-.3.09-.61.13-.91.19a1.78 1.78 0 0 1-1-.1 1.87 1.87 0 0 1-1.14-1.73 1.37 1.37 0 0 0-.69-1.18 1.7 1.7 0 0 0-.76-.23c-.31-.06-.62-.1-.92-.19Z",
    style: {
      fill: "#fff",
      transformOrigin: "399.21px 340.84px"
    },
    id: "eliaamzfraqch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.68 375.17c.31-.08.61-.12.91-.18a1.82 1.82 0 0 1 2.2 1.77 1.44 1.44 0 0 0 .65 1.22 1.63 1.63 0 0 0 .75.25c.31.06.61.1.91.18a9.18 9.18 0 0 1-.91.19 1.79 1.79 0 0 1-1-.1 1.85 1.85 0 0 1-1.13-1.73 1.42 1.42 0 0 0-.69-1.18 1.79 1.79 0 0 0-.77-.23c-.31-.06-.6-.1-.92-.19Z",
    style: {
      fill: "#fff",
      transformOrigin: "434.39px 376.79px"
    },
    id: "elaxt1nth7y0j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349 287.46c-.15.27-.34.51-.51.77a1.81 1.81 0 0 1-2.81.31 1.4 1.4 0 0 0-1.32-.4 1.68 1.68 0 0 0-.71.35 8.56 8.56 0 0 1-.77.51c.16-.27.34-.51.51-.77a1.83 1.83 0 0 1 .79-.65 1.86 1.86 0 0 1 2 .42 1.41 1.41 0 0 0 1.33.35 1.74 1.74 0 0 0 .7-.38c.32-.17.56-.36.79-.51Z",
    style: {
      fill: "#fff",
      transformOrigin: "345.94px 288.261px"
    },
    id: "elydkf17o3w4q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.93 267.21c-.15.27-.34.51-.51.77a1.81 1.81 0 0 1-2.81.31 1.39 1.39 0 0 0-1.32-.4 1.68 1.68 0 0 0-.71.35 8.56 8.56 0 0 1-.77.51c.16-.27.34-.51.51-.77a1.83 1.83 0 0 1 .79-.65 1.86 1.86 0 0 1 2 .42 1.4 1.4 0 0 0 1.33.35 1.74 1.74 0 0 0 .7-.38c.28-.17.52-.36.79-.51Z",
    style: {
      fill: "#fff",
      transformOrigin: "333.87px 268.011px"
    },
    id: "elysugs65ipyg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398 322.71c-.16.28-.34.52-.51.77a1.88 1.88 0 0 1-.77.67 1.83 1.83 0 0 1-2-.36 1.43 1.43 0 0 0-1.32-.4 1.69 1.69 0 0 0-.71.35c-.26.17-.5.36-.77.51.15-.27.34-.51.51-.77a1.8 1.8 0 0 1 .78-.65 1.89 1.89 0 0 1 2 .42 1.38 1.38 0 0 0 1.32.35 1.8 1.8 0 0 0 .71-.37c.28-.17.52-.36.76-.52Z",
    style: {
      fill: "#fff",
      transformOrigin: "394.96px 323.504px"
    },
    id: "el08ql6bgz7q1o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.46 257.08c-.15.27-.34.51-.51.77a1.84 1.84 0 0 1-.76.66 1.86 1.86 0 0 1-2.05-.35 1.43 1.43 0 0 0-1.32-.41 1.74 1.74 0 0 0-.71.35c-.26.17-.5.36-.77.52.15-.28.34-.52.51-.78a1.74 1.74 0 0 1 .79-.64 1.86 1.86 0 0 1 2 .42 1.44 1.44 0 0 0 1.36.38 1.87 1.87 0 0 0 .7-.38c.3-.2.49-.39.76-.54Z",
    style: {
      fill: "#fff",
      transformOrigin: "364.4px 257.873px"
    },
    id: "elxf2f6fyunhp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.28 242.12c-.15.27-.34.51-.51.77a1.92 1.92 0 0 1-.76.67 1.86 1.86 0 0 1-2.05-.36 1.4 1.4 0 0 0-1.32-.4 1.63 1.63 0 0 0-.71.35c-.26.17-.5.36-.77.51.15-.27.34-.51.51-.77a1.77 1.77 0 0 1 .79-.65 1.86 1.86 0 0 1 2 .42 1.39 1.39 0 0 0 1.33.35 1.74 1.74 0 0 0 .7-.38c.28-.17.51-.36.79-.51Z",
    style: {
      fill: "#fff",
      transformOrigin: "343.22px 242.916px"
    },
    id: "el16i5b331q35",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.27 276.12c.09.3.12.61.19.91a2 2 0 0 1-.07 1 1.85 1.85 0 0 1-1.7 1.19 1.43 1.43 0 0 0-1.22.65 1.59 1.59 0 0 0-.25.75c-.07.3-.1.61-.19.91-.08-.3-.12-.61-.18-.91a1.7 1.7 0 0 1 .1-1 1.86 1.86 0 0 1 1.73-1.14 1.38 1.38 0 0 0 1.18-.69 1.84 1.84 0 0 0 .23-.76c.06-.3.1-.61.18-.91Z",
    style: {
      fill: "#fff",
      transformOrigin: "364.655px 278.825px"
    },
    id: "elj6jw33cdvec",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.06 329.39c.08.3.12.61.18.91a1.82 1.82 0 0 1-1.77 2.2 1.42 1.42 0 0 0-1.22.65 1.71 1.71 0 0 0-.25.75c-.06.3-.1.61-.18.91-.09-.3-.13-.61-.19-.91a1.78 1.78 0 0 1 .1-1 1.88 1.88 0 0 1 1.73-1.14 1.37 1.37 0 0 0 1.18-.69 1.7 1.7 0 0 0 .23-.76c.06-.31.13-.62.19-.92Z",
    style: {
      fill: "#fff",
      transformOrigin: "357.44px 332.1px"
    },
    id: "elnni4wcnfgvp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429 354.07c.09.3.13.6.19.9a1.83 1.83 0 0 1-1.77 2.21 1.42 1.42 0 0 0-1.22.65 1.55 1.55 0 0 0-.25.75c-.06.3-.1.6-.18.9-.09-.3-.13-.6-.19-.9a1.82 1.82 0 0 1 .1-1 1.88 1.88 0 0 1 1.73-1.13 1.42 1.42 0 0 0 1.18-.69 1.79 1.79 0 0 0 .23-.77c.07-.32.11-.62.18-.92Z",
    style: {
      fill: "#fff",
      transformOrigin: "427.39px 356.775px"
    },
    id: "elef5w4qlwpnr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.6 283.5c.08.3.12.6.18.91a1.83 1.83 0 0 1-.07 1 1.86 1.86 0 0 1-1.7 1.2 1.42 1.42 0 0 0-1.22.65 1.71 1.71 0 0 0-.25.75c-.06.3-.1.6-.18.91-.09-.31-.12-.61-.19-.91a1.82 1.82 0 0 1 1.83-2.15 1.39 1.39 0 0 0 1.18-.69 1.59 1.59 0 0 0 .23-.76c.07-.31.1-.61.19-.91Z",
    style: {
      fill: "#fff",
      transformOrigin: "394.98px 286.21px"
    },
    id: "eljrwngsd3xyj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.6 369c.08.3.12.6.18.9a1.83 1.83 0 0 1-1.77 2.21 1.42 1.42 0 0 0-1.22.65 1.66 1.66 0 0 0-.25.75c-.06.3-.1.6-.18.9-.09-.3-.12-.6-.19-.9a1.91 1.91 0 0 1 .1-1 1.89 1.89 0 0 1 1.73-1.13 1.42 1.42 0 0 0 1.18-.69 1.59 1.59 0 0 0 .23-.77c.07-.29.1-.59.19-.92Z",
    style: {
      fill: "#fff",
      transformOrigin: "394.982px 371.705px"
    },
    id: "els8wpo69npc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.05 320.05c.09.3.12.61.18.91a1.8 1.8 0 0 1-1.76 2.2 1.43 1.43 0 0 0-1.22.65 1.59 1.59 0 0 0-.25.75c-.07.3-.1.61-.19.91-.08-.3-.12-.61-.18-.91a1.7 1.7 0 0 1 .1-1 1.86 1.86 0 0 1 1.72-1.14 1.39 1.39 0 0 0 1.19-.69 1.84 1.84 0 0 0 .23-.76c.06-.31.13-.62.18-.92Z",
    style: {
      fill: "#fff",
      transformOrigin: "411.435px 322.76px"
    },
    id: "elhysx3i1x0pu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.69 331.3c.09.3.12.6.18.9a1.81 1.81 0 0 1-1.76 2.21 1.41 1.41 0 0 0-1.22.65 1.55 1.55 0 0 0-.25.75c-.07.3-.1.6-.19.9-.08-.3-.12-.6-.18-.9a1.74 1.74 0 0 1 .1-1 1.86 1.86 0 0 1 1.72-1.13 1.43 1.43 0 0 0 1.19-.69 1.84 1.84 0 0 0 .23-.77c.06-.32.1-.62.18-.92Z",
    style: {
      fill: "#fff",
      transformOrigin: "328.076px 334.005px"
    },
    id: "el6tieryogcw3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.31 283.5a9.15 9.15 0 0 1 .18.91 1.82 1.82 0 0 1-.06 1 1.86 1.86 0 0 1-1.7 1.2 1.41 1.41 0 0 0-1.22.65 1.59 1.59 0 0 0-.25.75c-.07.3-.1.6-.19.91-.08-.31-.12-.61-.18-.91a1.77 1.77 0 0 1 .09-1 1.88 1.88 0 0 1 1.73-1.14 1.41 1.41 0 0 0 1.19-.69 1.84 1.84 0 0 0 .23-.76c.06-.32.1-.62.18-.92Z",
    style: {
      fill: "#fff",
      transformOrigin: "329.694px 286.21px"
    },
    id: "elk7bmp5poi0r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.75 252.43c.08.3.12.6.18.91a1.83 1.83 0 0 1-.07 1 1.86 1.86 0 0 1-1.7 1.2 1.42 1.42 0 0 0-1.22.65 1.71 1.71 0 0 0-.25.75c-.06.3-.1.6-.18.91-.09-.31-.12-.61-.19-.91a1.82 1.82 0 0 1 .1-1 1.89 1.89 0 0 1 1.73-1.13 1.39 1.39 0 0 0 1.18-.69 1.59 1.59 0 0 0 .23-.76c.07-.36.1-.63.19-.93Z",
    style: {
      fill: "#fff",
      transformOrigin: "347.13px 255.14px"
    },
    id: "el47vxjkz519l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.07 300.46c.08.31.12.61.18.91a1.83 1.83 0 0 1-1.77 2.21 1.42 1.42 0 0 0-1.22.65 1.66 1.66 0 0 0-.25.75c-.06.3-.1.6-.18.9-.09-.3-.13-.6-.19-.9a1.82 1.82 0 0 1 .1-1 1.89 1.89 0 0 1 1.73-1.13 1.42 1.42 0 0 0 1.18-.69 1.79 1.79 0 0 0 .23-.77c.06-.32.12-.62.19-.93Z",
    style: {
      fill: "#fff",
      transformOrigin: "342.45px 303.17px"
    },
    id: "elil1xzpovnkd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.1 306.92c.08.3.12.61.18.91a1.82 1.82 0 0 1-1.77 2.2 1.44 1.44 0 0 0-1.22.65 1.75 1.75 0 0 0-.25.75c-.06.3-.1.61-.18.91-.09-.3-.12-.61-.19-.91a1.79 1.79 0 0 1 .1-1 1.88 1.88 0 0 1 1.73-1.14 1.37 1.37 0 0 0 1.18-.69 1.59 1.59 0 0 0 .23-.76c.09-.31.09-.62.19-.92Z",
    style: {
      fill: "#fff",
      transformOrigin: "384.48px 309.63px"
    },
    id: "elloj24e5aad",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.25 360.86c.08.31.12.61.18.91a1.81 1.81 0 0 1-1.76 2.21 1.39 1.39 0 0 0-1.22.65 1.67 1.67 0 0 0-.26.74 9.15 9.15 0 0 1-.18.91c-.08-.3-.12-.6-.18-.91a1.78 1.78 0 0 1 .09-1 1.86 1.86 0 0 1 1.73-1.13 1.43 1.43 0 0 0 1.19-.69 1.94 1.94 0 0 0 .23-.77c.06-.31.1-.61.18-.92Z",
    style: {
      fill: "#fff",
      transformOrigin: "345.635px 363.57px"
    },
    id: "eljl8drx2ntm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.89 291.67c.16-.27.35-.51.52-.77a1.77 1.77 0 0 1 .76-.66 1.84 1.84 0 0 1 2 .35 1.45 1.45 0 0 0 1.33.41 1.71 1.71 0 0 0 .7-.35c.26-.18.5-.36.78-.52-.16.28-.35.52-.52.78a1.78 1.78 0 0 1-.78.64 1.88 1.88 0 0 1-2-.42 1.42 1.42 0 0 0-1.32-.35 1.87 1.87 0 0 0-.7.38c-.25.17-.49.36-.77.51Z",
    style: {
      fill: "#fff",
      transformOrigin: "381.935px 290.881px"
    },
    id: "elksj7nkyru5q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.38 313.88c.15-.27.34-.51.51-.77a1.81 1.81 0 0 1 2.81-.31 1.39 1.39 0 0 0 1.32.4 1.68 1.68 0 0 0 .71-.35 8.56 8.56 0 0 1 .77-.51c-.16.27-.34.51-.51.77a1.82 1.82 0 0 1-2.82.23 1.39 1.39 0 0 0-1.32-.35 1.87 1.87 0 0 0-.7.38c-.26.17-.5.36-.77.51Z",
    style: {
      fill: "#fff",
      transformOrigin: "357.44px 313.086px"
    },
    id: "el7xhoc3i5zfi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.76 346.6c.16-.28.35-.52.52-.77a1.81 1.81 0 0 1 2.81-.31 1.42 1.42 0 0 0 1.32.4 1.68 1.68 0 0 0 .71-.35 8.56 8.56 0 0 1 .77-.51c-.16.27-.34.51-.51.77a1.81 1.81 0 0 1-2.81.23 1.4 1.4 0 0 0-1.33-.35 1.71 1.71 0 0 0-.7.37c-.26.18-.54.36-.78.52Z",
    style: {
      fill: "#fff",
      transformOrigin: "340.825px 345.806px"
    },
    id: "elz5jjqss3t58",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.94 380.59c.16-.27.35-.51.52-.77a1.77 1.77 0 0 1 .76-.66 1.86 1.86 0 0 1 2 .35 1.42 1.42 0 0 0 1.32.41 1.71 1.71 0 0 0 .71-.36c.25-.17.49-.35.77-.51-.16.28-.34.52-.51.77a1.82 1.82 0 0 1-.79.65 1.88 1.88 0 0 1-2-.42 1.42 1.42 0 0 0-1.32-.35 1.87 1.87 0 0 0-.7.38c-.24.17-.48.36-.76.51Z",
    style: {
      fill: "#fff",
      transformOrigin: "347.98px 379.803px"
    },
    id: "elwzuec87jgw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.09 343.23c.15-.27.34-.51.51-.77a1.84 1.84 0 0 1 .76-.66 1.86 1.86 0 0 1 2.05.35 1.42 1.42 0 0 0 1.32.41 1.81 1.81 0 0 0 .71-.35c.25-.17.49-.36.77-.52-.16.28-.34.52-.51.78a1.74 1.74 0 0 1-.79.64 1.86 1.86 0 0 1-2-.42 1.44 1.44 0 0 0-1.33-.35 1.87 1.87 0 0 0-.7.38c-.28.17-.52.36-.79.51Z",
    style: {
      fill: "#fff",
      transformOrigin: "380.15px 342.437px"
    },
    id: "els0ux8rmrfyo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21 356.77c.15-.27.34-.51.51-.77a1.9 1.9 0 0 1 .76-.66 1.86 1.86 0 0 1 2 .35 1.43 1.43 0 0 0 1.32.41 1.74 1.74 0 0 0 .71-.35c.26-.17.5-.36.77-.52-.15.28-.34.52-.51.78a1.69 1.69 0 0 1-.79.64 1.86 1.86 0 0 1-2-.42 1.44 1.44 0 0 0-1.33-.35 1.87 1.87 0 0 0-.7.38c-.23.17-.47.36-.74.51Z",
    style: {
      fill: "#fff",
      transformOrigin: "402.245px 355.985px"
    },
    id: "eleibsk8b2wd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 367.05c.15-.27.34-.51.51-.77a1.77 1.77 0 0 1 .76-.66 1.86 1.86 0 0 1 2.05.35 1.42 1.42 0 0 0 1.32.41 1.71 1.71 0 0 0 .71-.36c.25-.17.49-.35.77-.51-.16.28-.34.52-.51.77a1.76 1.76 0 0 1-.79.65 1.86 1.86 0 0 1-2-.42 1.44 1.44 0 0 0-1.33-.35 1.87 1.87 0 0 0-.7.38c-.28.17-.52.36-.79.51Z",
    style: {
      fill: "#fff",
      transformOrigin: "365.06px 366.257px"
    },
    id: "el7l7glh9rnff",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 380.59c.16-.27.34-.51.51-.77a1.83 1.83 0 0 1 .76-.66 1.86 1.86 0 0 1 2.05.35 1.43 1.43 0 0 0 1.32.41 1.74 1.74 0 0 0 .71-.35c.26-.18.5-.36.77-.52-.15.28-.34.52-.51.78a1.78 1.78 0 0 1-.78.64 1.87 1.87 0 0 1-2-.42 1.43 1.43 0 0 0-1.32-.35 1.83 1.83 0 0 0-.71.38c-.3.17-.54.36-.8.51Z",
    style: {
      fill: "#fff",
      transformOrigin: "413.06px 379.796px"
    },
    id: "el0dzoppehqij6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.41 344c.15-.28.34-.52.51-.78a1.9 1.9 0 0 1 .76-.66 1.86 1.86 0 0 1 2.05.35 1.43 1.43 0 0 0 1.32.41 1.74 1.74 0 0 0 .71-.35c.26-.17.5-.36.77-.52-.15.28-.34.52-.51.78a1.69 1.69 0 0 1-.79.64 1.86 1.86 0 0 1-2-.42 1.43 1.43 0 0 0-1.32-.35 1.83 1.83 0 0 0-.71.38c-.28.18-.52.37-.79.52Z",
    style: {
      fill: "#fff",
      transformOrigin: "418.47px 343.198px"
    },
    id: "elv0sj14nyqj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.75 371.74c.16-.28.34-.52.51-.78a1.9 1.9 0 0 1 .76-.66 1.86 1.86 0 0 1 2.05.35 1.43 1.43 0 0 0 1.32.41 1.74 1.74 0 0 0 .71-.35c.26-.17.5-.36.77-.52-.15.28-.34.52-.51.78a1.72 1.72 0 0 1-.78.64 1.87 1.87 0 0 1-2-.42 1.4 1.4 0 0 0-1.32-.34 1.68 1.68 0 0 0-.71.37c-.29.17-.55.36-.8.52Z",
    style: {
      fill: "#fff",
      transformOrigin: "330.81px 370.938px"
    },
    id: "el0kwb47rr5ik",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 314.65c.15-.27.34-.51.51-.77a1.92 1.92 0 0 1 .76-.67 1.86 1.86 0 0 1 2.05.36 1.4 1.4 0 0 0 1.32.4 1.52 1.52 0 0 0 .71-.35c.26-.17.5-.36.77-.51a8.56 8.56 0 0 1-.51.77 1.8 1.8 0 0 1-.78.65 1.87 1.87 0 0 1-2-.42 1.4 1.4 0 0 0-1.32-.35 1.83 1.83 0 0 0-.71.38c-.28.17-.52.36-.8.51Z",
    style: {
      fill: "#fff",
      transformOrigin: "328.06px 313.853px"
    },
    id: "elgr2fnp6h9p6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.63 238.48c-.37 1.87-8.81 14.18-17.29 14.07-2.76-.05-3.2-15.13-3.2-15.13l-.29-1.1-4-15.48 17.93-12.37 2.6-1.64s.81 4.31 1.78 9.68c0 .25.09.5.13.77s.13.58.17.87c.16.8.31 1.62.45 2.44.11.62.21 1.22.3 1.88s.19 1.3.3 2a103 103 0 0 1 1.12 14.01Z",
    style: {
      fill: "#dd6a57",
      transformOrigin: "345.24px 229.69px"
    },
    id: "elgcexb2wp46n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.16 216.51a32.11 32.11 0 0 1-18.31 19.81l-4-15.48 17.93-12.37 2.6-1.64s.81 4.31 1.78 9.68Z",
    style: {
      fill: "#263238",
      transformOrigin: "344.005px 221.575px"
    },
    id: "elyimcrlqx7d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.87 197.85c-.74 28.06 16 31.67 22 31.82 5.49.14 24.21-.08 27.85-27.91s-9.18-37-21.72-38-27.39 6.03-28.13 34.09Z",
    style: {
      fill: "#dd6a57",
      transformOrigin: "336.097px 196.677px"
    },
    id: "elpnnns1stb68",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.13 189.36c.66-.11 1.24-.31 1.88-.48a3.2 3.2 0 0 0 1.82-.86 1 1 0 0 0-.05-1.22 2.49 2.49 0 0 0-2.47-.47 3.62 3.62 0 0 0-2.22 1.38 1.07 1.07 0 0 0 1.04 1.65Z",
    style: {
      fill: "#263238",
      transformOrigin: "316.463px 187.778px"
    },
    id: "elc4o1i89ytr6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.89 193.46a17.47 17.47 0 0 1-1.92-.32 3.14 3.14 0 0 1-1.88-.69 1 1 0 0 1-.06-1.22 2.49 2.49 0 0 1 2.42-.69 3.62 3.62 0 0 1 2.33 1.19 1.06 1.06 0 0 1-.89 1.73Z",
    style: {
      fill: "#263238",
      transformOrigin: "332.436px 191.962px"
    },
    id: "el9sc9r7v8fij",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.27 198.49c0-.07-.14.1-.14.18.19 1.9.09 4.11-1.59 4.86-.06 0 0 .12 0 .11 2.1-.44 2.21-3.38 1.73-5.15Z",
    style: {
      fill: "#263238",
      transformOrigin: "318.509px 201.057px"
    },
    id: "elgyxp3u18ur",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.43 196.61c-3.08 0-2.91 6.14-.05 6.17s2.62-6.14.05-6.17Z",
    style: {
      fill: "#263238",
      transformOrigin: "317.31px 199.695px"
    },
    id: "el57uce6v6oei",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.16 197.06c-.48.34-.94.94-1.53 1s-1.19-.59-1.64-1.22c0-.06-.09 0-.09.07 0 1.18.43 2.4 1.56 2.59s1.77-.85 2-2c.07-.25-.11-.58-.3-.44Z",
    style: {
      fill: "#263238",
      transformOrigin: "314.688px 198.169px"
    },
    id: "elcgjunx35f8j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.82 214.82c-.47.43-.95 1-1.65 1.07a5.06 5.06 0 0 1-2-.56.07.07 0 0 0-.09.1 2.57 2.57 0 0 0 2.4 1.12 2 2 0 0 0 1.56-1.64c-.04-.11-.15-.15-.22-.09Z",
    style: {
      fill: "#263238",
      transformOrigin: "330.055px 215.678px"
    },
    id: "elxlr78z3ornp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.26 207.15s-.22 2.86-.15 4.2a27.7 27.7 0 0 1 7.8.68c.6.16.56-.33-.12-.69a11.44 11.44 0 0 0-6.59-1.22c-.12-.37.43-4.4.22-4.4a11.73 11.73 0 0 0-3 .86c.3-6 1.56-11.84 1.77-17.79a.18.18 0 0 0-.35-.07c-1.76 6.07-2.26 12.93-2.73 19.09-.06.76 2.63-.4 3.15-.66Z",
    style: {
      fill: "#263238",
      transformOrigin: "324.72px 200.33px"
    },
    id: "elmskko2l8sc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.61 198.59a6.1 6.1 0 0 0-3.53-.28 5 5 0 0 0-1.76.78 4.54 4.54 0 0 0-1.31 1.54l-.59 1.09 1.21-.13a12.15 12.15 0 0 1 2.56 0 5.24 5.24 0 0 1 2.48.88 3.83 3.83 0 0 0-2.26-1.83 7.16 7.16 0 0 0-2.92-.33l.62 1a4.46 4.46 0 0 1 2.26-1.89 13.48 13.48 0 0 1 3.24-.83Z",
    style: {
      fill: "#263238",
      transformOrigin: "332.015px 200.32px"
    },
    id: "elkdr44b8hnwm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.14 203.56a10.1 10.1 0 0 1-2.59-1c-.19-.12-.92-.67-.88-.83a5.69 5.69 0 0 1 .48-1.34 3.7 3.7 0 0 0-.75 1.3 1.85 1.85 0 0 0 .94 1.25 5.37 5.37 0 0 0 2.8.62Z",
    style: {
      fill: "#263238",
      transformOrigin: "330.27px 201.979px"
    },
    id: "eletbmg0jre8r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.5 211.15s1.74 2.5 3.74 2.8c2.3.36 2.57-1.71 0-2.89-1.3-.61-3.74.09-3.74.09Z",
    style: {
      fill: "#263238",
      transformOrigin: "328.284px 212.401px"
    },
    id: "el6hlbm7hsffv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.23 214a4.66 4.66 0 0 1-2.31-1.23c.48-.71 1.58-1.5 4.05-.17.36.84-.28 1.58-1.74 1.4Z",
    style: {
      fill: "#ff99ba",
      transformOrigin: "328.994px 212.954px"
    },
    id: "elxplfa0oiftb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.55 202.43c-4.62.58-6.16-9.09-6.16-9.09s-9.42.48-13.19-12.92a20.91 20.91 0 0 0 4.72 11s-16.71-1-24.38-14.53c0 0 3.14 6.95 5.88 9.34 0 0-7.07-1.6-10.74-7.1 0 0-2.52 8.17-4.65 10.5 0 0-.73-29.11 26.36-27.33 0 0 16.92.3 23.63 13.36s-1.47 26.77-1.47 26.77Z",
    style: {
      fill: "#263238",
      transformOrigin: "338.346px 182.338px"
    },
    id: "el8a12muvgpzg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.23 203.79s5.59-9.11 9.69-7.17.26 14.9-4.29 16.91a4.74 4.74 0 0 1-6.5-2.16Z",
    style: {
      fill: "#dd6a57",
      transformOrigin: "361.396px 205.215px"
    },
    id: "elbnadsi6mo2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.73 200.31c.07 0 .09.09 0 .12-3.19 1.52-4.72 4.65-5.74 7.87.9-1.27 2.18-2 3.87-1 .09.05 0 .19-.08.18a2.9 2.9 0 0 0-3.14 1.21 13.32 13.32 0 0 0-1.38 2.68c-.14.3-.67.18-.58-.16a.19.19 0 0 1 0-.08c-.28-4.13 2.6-10.13 7.05-10.82Z",
    style: {
      fill: "#263238",
      transformOrigin: "361.226px 205.926px"
    },
    id: "elkksynf5co5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 212.07a1.31 1.31 0 1 0 1.23-1.38 1.3 1.3 0 0 0-1.23 1.38Z",
    style: {
      fill: "#fff",
      transformOrigin: "360.308px 211.998px"
    },
    id: "elv2uh2mbl13",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.14 209.9a.84.84 0 1 0 .79-.88.83.83 0 0 0-.79.88Z",
    style: {
      fill: "#fff",
      transformOrigin: "362.979px 209.859px"
    },
    id: "elfy93g795ci",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elb88igmit4h"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "269.085px 288.67px",
      transform: "rotate(-13.08deg)"
    },
    className: "animable",
    id: "el3n4ou37xqqt",
    d: "M261.63 265.59h14.91v46.16h-14.91z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235.74 145.13a63 63 0 1 0 75.65 47.14 63 63 0 0 0-75.65-47.14ZM261.26 255a49.76 49.76 0 1 1 37.2-59.71 49.76 49.76 0 0 1-37.2 59.71Z",
    style: {
      fill: "#a6a6a6",
      transformOrigin: "250.016px 206.491px"
    },
    id: "elvh6v6ybo37",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbomk6zxuk7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.59,
    y: 296.99,
    width: 22.54,
    height: 67.59,
    rx: 6.27,
    style: {
      fill: "#263238",
      transformOrigin: "278.86px 330.785px",
      transform: "rotate(-13.08deg)"
    },
    className: "animable",
    id: "elefbxf97u6mw"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elm3y12iihav"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "249.996px 206.52px"
    },
    className: "animable",
    id: "elr0js5hz2yd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.46 195.27a49.75 49.75 0 1 1-59.72-37.22 49.74 49.74 0 0 1 59.72 37.22Z",
    style: {
      fill: "#fff",
      transformOrigin: "249.996px 206.509px"
    },
    id: "elgqcotivyx54",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.68 209.29a49.78 49.78 0 0 1-52 46.94Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "273.68px 232.787px"
    },
    id: "eln4gsav7vz0g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.79 164.6-71.23 64.29a49.47 49.47 0 0 1-4-11.11 48.81 48.81 0 0 1-1.24-13.47l52.59-47.47a49.69 49.69 0 0 1 23.88 7.76Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "238.528px 192.865px"
    },
    id: "el352gffsdoe7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.09 190.5-67.85 61.23a49.69 49.69 0 0 1-8.43-4.93l72.25-65.2a48.13 48.13 0 0 1 4.03 8.9Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "258.95px 216.665px"
    },
    id: "elw05heb91ff",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.26 168.66 209 234.76c-.34-.5-.68-1-1-1.51l72.84-65.73c.5.36.97.73 1.42 1.14Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "245.13px 201.14px"
    },
    id: "elc2tobixqdz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.32 158.68 203.82 188c.55-1.39 1.17-2.75 1.85-4.07l26.43-23.86c1.37-.51 2.78-.98 4.22-1.39Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "220.07px 173.34px"
    },
    id: "elhraw8ra497",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M214.68 215.13a1.42 1.42 0 0 1 0-.2c-.18-1 .13.95 0 .3s-.2-1.54-.26-2.31a48.34 48.34 0 0 1 0-8.16c0-.39.07-.77.1-1.15 0-.12-.11.9 0 .09l.09-.7c.12-.9.27-1.8.45-2.69a44.45 44.45 0 0 1 1.53-5.79c.15-.45.32-.9.48-1.35.21-.61-.28.67.05-.13l.33-.79c.43-1 .9-2 1.4-3s1.15-2.07 1.78-3.06c.3-.46.6-.91.91-1.36.53-.77-.25.31.16-.23l.59-.78a45.84 45.84 0 0 1 6.08-6.3s.46-.37.12-.09.18-.15.24-.2l1-.79c.67-.5 1.35-1 2.05-1.44a51.79 51.79 0 0 1 4.54-2.71 3.75 3.75 0 0 0-4-6.36c-9.88 5.27-18 13.59-22.08 24.08a51.69 51.69 0 0 0-3.45 22.19 37.14 37.14 0 0 0 .64 5 3.76 3.76 0 0 0 4.66 2.53 3.87 3.87 0 0 0 2.53-4.67Z",
    style: {
      fill: "#fff",
      transformOrigin: "222.377px 192.619px"
    },
    id: "elhli7a3vsss8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 225.77a3.68 3.68 0 1 1-4.58-2.48 3.67 3.67 0 0 1 4.58 2.48Z",
    style: {
      fill: "#fff",
      transformOrigin: "214.472px 226.815px"
    },
    id: "el010wi1aonsht9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.13 257.3c9 32.54 13.32 65.21 8.34 82.06-3.18 10.74-10.85 18-15.73 20.4-11.41 5.64-49.26-2.36-73.92-7.32-6.06-1.22 8.23-50.05 14.32-47.46 9 3.81 36.55 8.95 37.31 9.2 1.63.56 5-34.75 7.38-55.45 3.29-28.84 17.11-20.22 22.3-1.43Z",
    style: {
      fill: "#dd6a57",
      transformOrigin: "340.961px 300.874px"
    },
    id: "elw4bpr4oczp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.43 295.68c-2.68 4.37.8 8.37.8 8.37a10.92 10.92 0 0 0-5.12 5.39c-1.61 4.2 4.27 8.57 4.27 8.57a13.41 13.41 0 0 0-4.49 6.54c-1.14 4.18 4.17 9.43 4.17 9.43a11.81 11.81 0 0 0-.33 8.24c2.65 7.11 14 9.44 21.2 11s29.08-.8 33.3-.82l10.35-46.13s-30.31-16.15-39-16.77c-7.39-.5-22.14 1.28-25.15 6.18Z",
    style: {
      fill: "#dd6a57",
      transformOrigin: "278.155px 321.586px"
    },
    id: "ellixy1xyk2t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.71 303.38c8-1.31 15.86-.21 23.81.44a.14.14 0 0 1 0 .28c-7.91-.74-15.86.09-23.77-.33a.2.2 0 0 1-.04-.39Z",
    style: {
      fill: "#263238",
      transformOrigin: "261.615px 303.434px"
    },
    id: "el0pmgjru7wfh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.67 317.44a20.65 20.65 0 0 1 5.48.35q2.89.38 5.77.86 5.77 1 11.48 2.21c.17 0 .16.3 0 .27a283.188 283.188 0 0 0-17.33-2.33 24.76 24.76 0 0 1-5.43-.83.28.28 0 0 1 .03-.53Z",
    style: {
      fill: "#263238",
      transformOrigin: "259.994px 319.261px"
    },
    id: "elwfl3e0p6z38",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.22 334c1.56-.27 3.38.29 4.92.58 1.75.33 3.49.64 5.24.95 3.5.62 7 1.23 10.52 1.73.17 0 .15.3 0 .27-3.58-.48-7.16-.92-10.73-1.43-1.75-.25-3.51-.52-5.26-.79-1.49-.23-3.37-.35-4.7-1.13a.1.1 0 0 1 .01-.18Z",
    style: {
      fill: "#263238",
      transformOrigin: "258.589px 335.73px"
    },
    id: "el22e7qahhe5c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.31 290.9c-3.63.47-7.79 1.27-10.14 4.36a6.56 6.56 0 0 0-1.49 4.69 6.31 6.31 0 0 0 2.24 4.05 8.1 8.1 0 0 0-5.54 6.6 5.52 5.52 0 0 0 1.43 4.17c.5.59 1.07 1.11 1.62 1.65s1.16 1 1.73 1.47a15.22 15.22 0 0 0-1.73 1.58 12.17 12.17 0 0 0-1.61 1.9 8.49 8.49 0 0 0-1.58 4.65 8.34 8.34 0 0 0 1.66 4.59 9.51 9.51 0 0 0 3.33 3.34.08.08 0 0 0 .09-.13 13.72 13.72 0 0 1-2.71-3.41 8.77 8.77 0 0 1-1.37-4.54 9.1 9.1 0 0 1 1.5-4.27 22.43 22.43 0 0 1 1.38-2 17.47 17.47 0 0 0 1.38-1.66s-1.19-1.26-1.61-1.8-.83-1.12-1.21-1.71a5.52 5.52 0 0 1-1-3.87 7.13 7.13 0 0 1 1.68-3.44c.84-1 1.93-1.79 2.81-2.77a.45.45 0 0 0 .05-.35c-2-3.12-1.75-6.08.39-8.39a13.58 13.58 0 0 1 3.77-2.73 33.53 33.53 0 0 1 5-1.81c.07-.01.04-.18-.07-.17Z",
    style: {
      fill: "#263238",
      transformOrigin: "250.829px 312.429px"
    },
    id: "elehjr2o9txs5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.61 358.09c-2.13-.66-4.38-1-6.56-1.48s-4.38-.93-6.58-1.37-4.49-.88-6.73-1.3-4.33-.89-6.51-1.15a26.73 26.73 0 0 0-6.32.14q-3.17.36-6.36.51a91.85 91.85 0 0 1-12.85-.28 86.87 86.87 0 0 1-14.31-2.55c-.1 0-.13.12 0 .15a77.78 77.78 0 0 0 25.23 4c2.12 0 4.25-.13 6.36-.34a56.63 56.63 0 0 1 6.36-.54 40.91 40.91 0 0 1 6.68 1c2.21.41 4.41.83 6.62 1.22 2.5.44 5 .89 7.51 1.28s5 .95 7.46 1.13c.18-.04.19-.37 0-.42Z",
    style: {
      fill: "#263238",
      transformOrigin: "291.526px 354.56px"
    },
    id: "eldq6jysdslt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.67 316.2c-3.2-1.09-6.58-1.77-9.87-2.56s-6.62-1.55-9.93-2.3c-6.32-1.43-12.72-2.64-19-4.39-1.65-.46-3.28-1-4.89-1.54-.81-.29-1.6-.61-2.39-1s-1.7-.63-2.48-1c-.09-.06-.16.08-.07.14.63.39 1.21.86 1.86 1.24s1.44.76 2.18 1.1a41 41 0 0 0 4.15 1.63c2.94 1 6 1.69 9 2.39 6.6 1.51 13.21 3 19.83 4.43 1.86.4 3.73.8 5.6 1.17s3.91.83 5.89 1.05a.19.19 0 0 0 .12-.36Z",
    style: {
      fill: "#263238",
      transformOrigin: "331.394px 309.981px"
    },
    id: "elh66dpd1b83r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.26 304.1 45.74 6.22s-8.36-47.55-17.25-63.3c-8.77-15.54-18.45-5.27-22.14 13.53-4.14 20.84-6.35 43.55-6.35 43.55Z",
    style: {
      fill: "#37474f",
      transformOrigin: "368.13px 274.88px"
    },
    id: "eljr7sbnmw1ld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.57 303.43c-1.28-.3-2.59-.49-3.87-.77s-2.51-.47-3.77-.67c-2.57-.4-5.15-.76-7.73-1.11-5.08-.7-10.15-1.47-15.25-2-2.9-.32-5.79-.75-8.69-1a.08.08 0 0 0 0 .16c5.05 1.18 10.2 2.06 15.32 2.89s10.16 1.61 15.26 2.17c1.43.15 2.86.34 4.3.41s2.95.2 4.42.23a.13.13 0 0 0 .01-.31Z",
    style: {
      fill: "#263238",
      transformOrigin: "367.95px 300.81px"
    },
    id: "elgbd6o6nn9pm",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-42",
    className: "animable",
    style: {
      transformOrigin: "379.063px 127.699px",
      animation: "2.8s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn,6s Infinite linear floating",
      animationDelay: "0s,2.8s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.63 130.91a30.52 30.52 0 0 1-51 19.31l-15.28 2.25 7.65-13.21a30.54 30.54 0 1 1 58.65-8.35Z",
    style: {
      fill: "#fff",
      transformOrigin: "379.583px 127.722px",
      animation: "2.8s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn",
      animationDelay: "0s"
    },
    id: "elbzgwmk9z595",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.63 130.91a30.66 30.66 0 0 1-6.16 15.48 28 28 0 0 1-6 5.91 31 31 0 0 1-15.59 6.06 28.56 28.56 0 0 1-4.24.08 25.92 25.92 0 0 1-4.22-.44 30.81 30.81 0 0 1-15.11-7.45l.36.11-15.25 2.34-1.11.17.56-1 7.6-13.23v.52a30.91 30.91 0 0 1 38.29-41 31.26 31.26 0 0 1 11.77 7.22 30.66 30.66 0 0 1 9.1 25.23Zm0 0a30.2 30.2 0 0 0-34.62-33 30.06 30.06 0 0 0-12.62 5 31.4 31.4 0 0 0-9.13 10 30.16 30.16 0 0 0-3.88 12.92 30.69 30.69 0 0 0 2.15 13.3l.11.28-.14.25-7.69 13.18-.55-.81 15.29-2.14h.21l.15.14a30.16 30.16 0 0 0 14.63 7.53 26.17 26.17 0 0 0 4.14.51 30.69 30.69 0 0 0 4.18 0 30 30 0 0 0 8.15-1.8 28.38 28.38 0 0 0 7.37-4 33 33 0 0 0 3.22-2.69 34.59 34.59 0 0 0 2.78-3.15 30.68 30.68 0 0 0 6.25-15.52Z",
    style: {
      fill: "#263238",
      transformOrigin: "379.057px 127.699px",
      animation: "2.8s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn",
      animationDelay: ".5599999999999999s",
      opacity: 0
    },
    id: "elmnriq5307g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.33 142a3 3 0 0 1 3-3.14 3.14 3.14 0 0 1 0 6.28 3 3 0 0 1-3-3.14Zm1.27-7.24-.71-24.31h4.86l-.75 24.28Z",
    style: {
      fill: "#1952a9",
      transformOrigin: "370.398px 127.795px",
      animation: "2.8s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn",
      animationDelay: "1.1199999999999999s",
      opacity: 0
    },
    id: "elqyrwvag9hsa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 142a3 3 0 0 1 3-3.14 3.14 3.14 0 0 1 0 6.28 3 3 0 0 1-3-3.14Zm1.27-7.24-.71-24.31h4.86l-.71 24.31Z",
    style: {
      fill: "#1952a9",
      transformOrigin: "382.068px 127.795px",
      animation: "2.8s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn",
      animationDelay: "1.6799999999999997s",
      opacity: 0
    },
    id: "eltwf46w8qv8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.63 142a3 3 0 0 1 3-3.14 3.14 3.14 0 0 1 0 6.28 3 3 0 0 1-3-3.14Zm1.27-7.24-.71-24.31h4.86l-.71 24.31Z",
    style: {
      fill: "#1952a9",
      transformOrigin: "393.698px 127.795px",
      animation: "2.8s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn",
      animationDelay: "2.2399999999999998s",
      opacity: 0
    },
    id: "eloi334go7pm",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfound);
export default __webpack_public_path__ + "static/media/notfound.ef35ca2f9076adbc048b49ec3b180de0.svg";
export { ForwardRef as ReactComponent };